<template>
  <v-window-item value="disposals">
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="text-h6">Asset Disposals</h2>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pa-1">
          <v-data-table
              :headers="disposalHeaders"
              :items="disposalsData"
              :loading="loading"
              :hover="true"
              density="compact"
              elevation="0"
              class="border-sm rounded-md"
          >

          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-window-item>
</template>

<script>

export default {
  props: {
    disposalsData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
    }
  },
  components: {},
  data: () => ({
    dialog: false,
    loading: false,
    disposalHeaders: [

      { title: "Code", key: "asset_disposal.code", align: "center", sortable: false },
      { title: "Customer Name", key: "asset_disposal.customer.company_owner_name", align: "center", sortable: false },
      { title: "Disposal Date", key: "asset_disposal.disposal_date", align: "center", sortable: false },
      { title: "Reference No", key: "asset_disposal.reference_no", align: "center", sortable: false },
      { title: "Sale Value", key: "sale_value", align: "center", sortable: false },
      { title: "Total Gain/Loss", key: "asset_disposal.total_gain_loss", align: "center", sortable: false },
      { title: "Asset Location", key: "asset_location.name", align: "center", sortable: false },
    ],
  }),
  computed: {},
  watch: {
    disposalsData: {
      handler(newVal, oldVal) {
        console.log('New disposals:', newVal)
        console.log('Old disposals:', oldVal)
      },
      deep: true, // optional if array objects may change internally
      immediate: true // optional if you want it to run right away on mount
    }
  },
  created() {
  },
  methods: {},
  setup(props, {emit}){},
  mounted() {

  },
}
</script>